// extracted by mini-css-extract-plugin
module.exports = {"textAreaWrapper":"_cad1929c","textArea":"_71f5a56f","charCount":"_520a163e"};